import { styled } from '@mui/material/styles';

export const Fullscreen = styled('div')`
  display: flex;
  height: 100%;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  color: ${({ theme }) => theme.palette.white['06']};
`;

export const Compact = styled('div')`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 100px);
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 12px;
  color: ${({ theme }) => theme.palette.white['06']};
`;
